import React from 'react';
export function toArray(children) {
  var childrens = [];
  React.Children.forEach(children, function each(c) {
    childrens.push(c);
  });
  return childrens;
}